import registerStatusmapDirective from './StatusMapDirective';

export default function registerStatusmap(angular) {
    registerStatusmapDirective(angular.module('assessmentFrontendDirectives'));
}